import { gql } from "@apollo/client";

// ==================== NOTIFICATIONS MODULE (in-app channel) ====================
// The bell + inbox consume the same InAppNotification collection every rule engine
// (shifts, employees, …) writes to. Extracted to its own module 2026-07-16.

const NOTIFICATION_FIELDS = `
    id
    type
    title
    message
    isRead
    readAt
    referenceType
    referenceId
    createdAt
`;

/** The caller's own inbox, newest first. */
export const GET_MY_NOTIFICATIONS = gql`
    query GetMyNotifications($limit: Int, $offset: Int) {
        myNotifications(limit: $limit, offset: $offset) {
            ${NOTIFICATION_FIELDS}
        }
    }
`;

/** Unread badge count — polled by the navbar bell. */
export const GET_UNREAD_NOTIFICATION_COUNT = gql`
    query GetUnreadNotificationCount {
        unreadNotificationCount
    }
`;

export const MARK_NOTIFICATION_READ = gql`
    mutation MarkNotificationRead($id: ID!) {
        markNotificationRead(id: $id) {
            id
            isRead
            readAt
        }
    }
`;

export const MARK_ALL_NOTIFICATIONS_READ = gql`
    mutation MarkAllNotificationsRead {
        markAllNotificationsRead
    }
`;

/** ADMIN only: the tenant-wide log — every notification to anyone, read state included. */
export const GET_NOTIFICATIONS_LOG = gql`
    query GetNotificationsLog($limit: Int, $offset: Int, $type: String, $recipientClientId: ID, $since: DateTime) {
        notificationsLog(limit: $limit, offset: $offset, type: $type, recipientClientId: $recipientClientId, since: $since) {
            ${NOTIFICATION_FIELDS}
            recipientClientId
            recipientEmployeeId
            recipientName
        }
    }
`;
